import { SavedMessage } from "../../../../../models"

export const UPDATE_LATEST_SAVED_MESSAGE = 'UPDATE_LATEST_SAVED_MESSAGE'

export interface UpdateLatestSavedMessageAction {
    type: string
    userId: string
    message: SavedMessage
}
export const updateLatestSavedMessage = (userId: string, message: any): UpdateLatestSavedMessageAction => ({
    type: UPDATE_LATEST_SAVED_MESSAGE,
    userId,
    message
})
